import { FileText, Building } from 'lucide-react';
import { useProfile } from '../../../../../context/profile/ProfileContext';

const BusinessGstSection = () => {
  const {
    formData,
    handleInputChange,
    isEditing,
    renderInput
  } = useProfile();

  return (
    <div>
      <div className="border-b border-slate-100 pb-2.5 mb-4">
        <h2 className="font-semibold text-slate-900 text-base">GST details</h2>
        <p className="text-xs text-slate-500 mt-0.5 font-normal">Registered GST details for tax invoices &amp; ITC</p>
      </div>
      <div className="grid grid-cols-1 gap-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {renderInput("GST Number (GSTIN)", "gstin", formData.gstin, "text", !isEditing, FileText)}
          {renderInput("Registered Legal Name", "gst_legal_name", formData.gst_legal_name, "text", !isEditing, Building)}
        </div>
        <div className="space-y-1.5">
          <label className="block text-xs font-semibold text-slate-700 tracking-wide mb-1.5">
            Registered Business Address
          </label>
          <textarea
            name="gst_address"
            value={formData.gst_address}
            onChange={handleInputChange}
            disabled={!isEditing}
            rows="2"
            placeholder="Registered business address as per GST certificate"
            className={`w-full px-4 py-2.5 rounded-xl border text-sm font-medium focus:outline-none focus:ring-2 focus:ring-[#067978]/20 focus:border-[#067978] transition-all resize-none ${
              isEditing ? 'bg-white border-slate-200 text-slate-800' : 'bg-slate-50 border-slate-200 text-slate-500 cursor-not-allowed'
            }`}
          />
        </div>
      </div>
    </div>
  );
};

export default BusinessGstSection;
